// @flow

export const usernameValidator = (value: string): ?string => {
    if(!value) {
        return `Username must not be blank`;
    }
};

export const passwordValidator = (value: string): ?string => {
    if(!value) {
        return `Password must not be blank`;
    }
};

export const verificationCodeValidator = (value: string): ?string => {
    if(!value) {
        return `Verification code must not be blank`;
    }
    if(!/^\d+$/g.test(value)) {
        return `Verification code should only contain numbers`;
    }
};

export const emailValidator = (value: string): ?string => {
    if(!value) {
        return `Email must not be blank`;
    }

    if(!/^\S+@\S+$/g.test(value)) {
        return `Email must contain a valid email address`;
    }
};

export const choosePasswordValidator = (value: string): ?string => {
    if(!value) {
        return `Password must not be blank`;
    }
    if(value.length < 8) {
        return `Password must be at least 8 characters long`;
    }
};

export const choosePasswordConfirmValidator = (value: string, {topLevelValue}: any): ?string => {
    if(value !== topLevelValue.choosePassword) {
        return `Passwords must match`;
    }
};
